import classnames from 'classnames';
import React from 'react';

import { PopupBuilderTextContentSection } from '../contentTypes';
import { Div } from '../HTMLElement';
import { TextAlign } from '../interfaces';
import { formatHtml } from '../util';
import { PropsWithCustomComponent, VariantsController } from '../VariantsController';

export interface PopupBuilderTextComponentProps extends PopupBuilderTextContentSection {}

const PopupBuilderTextComponent = ({ options, text }: PopupBuilderTextComponentProps) => {
  const textAlign = options?.textAlign as TextAlign;
  const headingType = options?.headingType as string;

  return (
    <React.Fragment>
      {options?.enabled && (
        <Div className={classnames('popup-builder-text-component', options.classes)} textAlign={textAlign}>
          {React.createElement(headingType, null, formatHtml(text))}
        </Div>
      )}
    </React.Fragment>
  );
};

export type PopupBuilderTextComponentVariants = '';

const PopupBuilderTextComponentController = (props: PropsWithCustomComponent<PopupBuilderTextComponentProps>) => (
  <VariantsController<PopupBuilderTextComponentProps, PopupBuilderTextComponentVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: PopupBuilderTextComponent,
      name: 'PopupBuilderTextComponent',
    }}
  />
);
export { PopupBuilderTextComponentController as PopupBuilderTextComponent };
